import _u from './util';

document.getElementById('feedback-submit').addEventListener('click', function () {
    var name = document.getElementById("name").value;
    var emailId = document.getElementById("emailId").value;
    var desc = document.getElementById("feedbackDesc").value;

    if (name != '' && (emailId != '' && validateEmail(emailId)) && desc != '') {
        wmdPageLink('fy-fdbk_submit', this);
        desc =  desc + ' - Contact email address: ' + emailId; // check about removed HTML for line-breaks
        let emailData = {
            workflow: 'medscape_ba_sharethis',
            params: {
                pubName: ' ',
                subject: 'Medscape For You: Feedback',
                linkURL: window.location.href,
                contentTitle: 'My Medscape',
                message: desc.replace(/\s\s+/g,' ').trim(),
                pubDate: ' ',
				page : 'foryou'
            }
        };

        var headerandDataObject = {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(emailData)
        }

        _u.apiPost('//api.' + getDomain() + 'medscape.com/servicegateway/v2/auth/notificationservice/sendfeedback', headerandDataObject).then(data => {
            document.getElementById('feedback-main-section').style.display = "none";
            document.getElementById('thank-you-section').classList.add("active");
            setTimeout(function () {
                document.getElementById("overlay").classList.remove("active");
                document.getElementById('feedback-container').classList.remove("active");
                document.getElementById('feedback-submit').classList.remove("active");
            }, 2000);
        }).catch((error) => {
            console.log(error);
        });
    }
});

function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

document.getElementById('close-feedback-buttons').addEventListener('click', function () {
    document.getElementById('feedback-button-container').style.display = "none";
    wmdPageLink('fy-fdbk_clse', this);
});

document.getElementById('feedback-button').addEventListener('click', function () {
    document.getElementById('overlay').classList.add("active");
    document.getElementById('feedback-container').classList.add("active");
    document.getElementById('thank-you-section').classList.remove("active");
    document.getElementById('feedback-main-section').style.display = "block";
    document.getElementById("feedbackDesc").value = '';
    document.getElementById('feedback-submit').classList.remove("active");
    wmdPageLink('fy-fdbk_tab', this);
});

document.getElementById('close-feedback-conatiner').addEventListener('click', function () {
    document.getElementById("overlay").classList.remove("active");
    document.getElementById('feedback-container').classList.remove("active");
    document.getElementById('feedback-submit').classList.remove("active");
});

document.addEventListener('click', function (e) {
    if (e.target.id === 'overlay' && document.getElementById('overlay').classList.contains('active')) {
        document.getElementById("overlay").classList.remove("active");
        document.getElementById('feedback-container').classList.remove("active");
        document.getElementById('feedback-submit').classList.remove("active");
    }
}, false);

document.getElementById('name').addEventListener('keyup', function () {
    enableDisableSubmitButton();
});

document.getElementById('emailId').addEventListener('keyup', function () {
    enableDisableSubmitButton();
});

document.getElementById('feedbackDesc').addEventListener('keyup', function () {
    enableDisableSubmitButton();
});

function enableDisableSubmitButton() {
    if (document.getElementById('name').value != '' && document.getElementById('emailId').value != '' && document.getElementById('feedbackDesc').value != ''){
        document.getElementById('feedback-submit').removeAttribute("disabled");
        document.getElementById('feedback-submit').classList.add("active");
    } else {
        document.getElementById('feedback-submit').setAttribute("disabled", null);
        document.getElementById('feedback-submit').classList.remove("active");
    }
}
